export const NO_CHAYNS = `
[chaynsLogger] chaynsLogger requires chayns to be defined. The chayns API is either not loaded or loaded to after chaynsLogger.
`;

export const NO_CONSOLE = `
[chaynsLogger] Either console or console.error is not defined. This may be due to an unsupported browser version or
an external library that conflicts with chaynsLogger.
`;